import { Sparkles, RefreshCw } from 'lucide-react';
import { useVersionCheck } from '@/hooks/useVersionCheck';
import { Button } from '@/components/ui/Button';

// Toast persistente no canto inferior direito quando um deploy novo é
// detectado (via hook useVersionCheck). Botão Recarregar chama
// window.location.reload() — bypass do cache HTTP conservando localStorage
// (token JWT persiste, usuário não é deslogado).
//
// Sem animação de entrada — se aparecer, é porque tem algo pendente.
// Sem "dismiss" — o objetivo é forçar recarregar antes que features novas
// quebrem o app com bundle antigo (bug real 2026-07-08).

export function UpdateToast() {
  const updateAvailable = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex max-w-sm items-start gap-3 rounded-xl border border-brand bg-bg-elevated p-4 shadow-2xl">
      <div className="rounded-full bg-brand-bg p-2 text-brand">
        <Sparkles size={16} />
      </div>
      <div className="flex-1">
        <div className="text-sm font-medium text-text-primary">Nova versão disponível</div>
        <div className="mt-0.5 text-xs text-text-muted">
          Recarregue pra aplicar as atualizações e evitar falhas.
        </div>
        <div className="mt-3">
          <Button
            size="sm"
            onClick={() => window.location.reload()}
            className="inline-flex items-center gap-2"
          >
            <RefreshCw size={13} />
            Recarregar
          </Button>
        </div>
      </div>
    </div>
  );
}
